import { Dispatch, SetStateAction } from "react";
import "./Searchbar.css";

interface Props {
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string;
  variant?: "default" | "finance" | "supervisor";
  entityToSearch: string;
}

function Searchbar({ setSearchInput, searchInput, variant = "default", entityToSearch }: Props) {
  return (
    <input
      type="text"
      placeholder={`Nach ${entityToSearch} suchen...`}
      className={`search ${variant !== "default" ? variant : ""}`}
      value={searchInput}
      onChange={(e) => setSearchInput(e.target.value)}
    />
  );
}

export default Searchbar;
